import React from "react";
import FormSubmitProps from "@/src/types/FormSubmitProps";
import PersonalMessage from "@/src/components/Form/AbstractLitigationCase/PersonalMessage";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";

type ContractDescriptionProps = {
  submitProps: FormSubmitProps;
  product: AbstractCase;
  applicationStatus: number;
};

export default function ContractDescription({ submitProps, product, applicationStatus }: ContractDescriptionProps) {
  return <PersonalMessage submitProps={submitProps} product={product} applicationStatus={applicationStatus} />;
}
